import { FUZZY_FEATURE } from "../../../api/content/searchApi";
import { isProblemWithCode, type UiError } from "../../../errors/uiError";

/** The server refused a query because its engine has no fuzzy words (light mode). */
export function isFuzzyRefusal(error: UiError): boolean {
  return isProblemWithCode(error, "invalid_value") && error.kind === "problem" && error.problem.details["search_feature"] === FUZZY_FEATURE;
}
